import t from "./_Stack.js";
import d from "./_assignMergeValue.js";
import g from "./_baseFor.js";
import a from "./_baseMergeDeep.js";
import M from "./isObject.js";
import v from "./keysIn.js";
import x from "./_safeGet.js";
function D(f, r, e, n, i) {
  f !== r && g(r, function(o, m) {
    if (i || (i = new t()), M(o))
      a(f, r, m, e, D, n, i);
    else {
      var p = n ? n(x(f, m), o, m + "", f, r, i) : void 0;
      p === void 0 && (p = o), d(f, m, p);
    }
  }, v);
}
export {
  D as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseMerge.js
// module id = 1441
// module chunks = 41